import { createContext, useState } from 'react';

interface NavContextValue {
  items: { title: string; slug: string }[];
  active: string;
  mobileNavOpen: boolean;

  setActive: React.Dispatch<React.SetStateAction<string>>;
  setItems: React.Dispatch<
    React.SetStateAction<{ title: string; slug: string }[]>
  >;
  setMobileNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const initialContextState = {
  items: [],
  active: '',
  mobileNavOpen: false,

  setActive: () => {},
  setItems: () => {},
  setMobileNavOpen: () => {}
};

const NavContext = createContext<NavContextValue>(initialContextState);

function NavProvider({ children }: React.PropsWithChildren) {
  const [active, setActive] = useState<NavContextValue['active']>(
    initialContextState.active
  );
  const [mobileNavOpen, setMobileNavOpen] = useState<
    NavContextValue['mobileNavOpen']
  >(initialContextState.mobileNavOpen);

  const [items, setItems] = useState<NavContextValue['items']>([]);

  return (
    <NavContext.Provider
      value={{
        items,
        active,
        setActive,
        mobileNavOpen,
        setMobileNavOpen,
        setItems
      }}
    >
      {children}
    </NavContext.Provider>
  );
}

export { NavContext, NavProvider };
